export const HTTP = {
  OK: 200,
  PARTIAL_CONTENT: 206,
  NOT_MODIFIED: 304,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  INTERNAL_SERVICE_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  UNKNOWN_RESPONSE: 666
};

// set this global variable true to prevent any request - used to terminate infinite loops while debugging
export const FETCH_KILL_SWITCH = '__terminate-scripting-fetch';

export const MAX_RETRY_ATTEMPTS = 3;

export const SIGNAL_KEY = '__script-creator-signal'; // shooting for obscure

export const SIGNAL = [
  'ANOTHER_SERVICE_PAGE_AWAITS',
  'EMPTY_SERVICE_PAGE'
].reduce((result, key) => { result[key] = `${key.toLowerCase()}`; return result; }, {});

